import { API, LegacyAPI, SuggestAPI, ApiConfiguration } from '.';
import { transformSearchRequest, transformSearchResponse, transformSuggestResponse } from '../transforms';
export class HybridAPI extends API {
    constructor(configuration) {
        super(configuration);
        this.requesters = {
            legacy: new LegacyAPI(new ApiConfiguration({ origin: configuration.origin, cache: this.configuration.cache })),
            suggest: new SuggestAPI(new ApiConfiguration({ origin: configuration.origin, cache: this.configuration.cache })),
        };
    }
    async getMeta(requestParameters) {
        const legacyRequestParameters = requestParameters;
        return this.requesters.legacy.getMeta(legacyRequestParameters);
    }
    async getSearch(requestParameters) {
        const legacyRequestParameters = transformSearchRequest(requestParameters);
        const legacyData = await this.requesters.legacy.getSearch(legacyRequestParameters);
        return transformSearchResponse(legacyData, requestParameters);
    }
    async getFinder(requestParameters) {
        const legacyRequestParameters = transformSearchRequest(requestParameters);
        const legacyData = await this.requesters.legacy.getFinder(legacyRequestParameters);
        return transformSearchResponse(legacyData, requestParameters);
    }
    async getAutocomplete(requestParameters) {
        const legacyRequestParameters = transformSearchRequest(requestParameters);
        const suggestParams = {
            siteId: legacyRequestParameters.siteId,
            language: 'en',
            query: legacyRequestParameters.q,
            suggestionCount: (requestParameters.suggestions || {}).count || 5,
        };
        if (!((requestParameters.search || {}).query || {}).spellCorrection) {
            suggestParams.disableSpellCorrect = true;
        }
        const suggestResults = await this.requesters.suggest.getSuggest(suggestParams);
        const transformedSuggestResults = transformSuggestResponse(suggestResults);
        const q = (suggestResults.suggested || {}).text || transformedSuggestResults.correctedQuery || suggestResults.query;
        const queryParameters = {
            ...legacyRequestParameters,
            redirectResponse: 'full',
            q,
        };
        const legacyResults = await this.requesters.legacy.getAutocomplete(queryParameters);
        const searchResults = transformSearchResponse(legacyResults, requestParameters);
        return {
            ...searchResults,
            search: {
                query: q,
            },
            autocomplete: transformedSuggestResults,
        };
    }
}
